<style type="text/css">
  @import url("index.css");
</style>
<template>
  <div class="error-wrapper-bg">
    <div class="error-wrapper">
      <div class="brand">
        <div class="pin"></div>
        <div class="brand-animate">
          <div class="line leftline"></div>
          <div class="line rightline"></div>
          <div class="box">
            <div class="box-inner">
              <h1 class="error">401</h1>
              <h4 class="error-info">Unauthorized</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="info">
        <span class="error-notify-warning">401</span>
        <p class="error-notify-tips">未授权：由于凭据无效，访问被拒绝。</p>
        <p>错误信息：</p>
        <p class="error-text">你无权使用所提供的凭据查看此目录或页面</p>
        <p>您可以：</p>
        <p class="error-text">检查认证信息验是否正确（令牌、用户名、密码错误）</p>
        <br>
        <p class="error-text">
          <Button type="primary" @click="reLogin">重新登录</Button>
          <Button  @click="backToHome">返回首页</Button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'not-found',
  data () {
    return {}
  },
  methods: {
    reLogin () {
      // const queryParams = this.$route.query
      // this.$router.push({ path: 'login', query: queryParams })
      window.location.href = '/login'
    },
    backToHome () {
      this.$router.push('/')
    }
  }
}
</script>
